<template>
    <AppLayout v-bind="appSharedData.getAppSidebarLayoutProps(pageMeta)">
        <div
            v-if="type"
            class="text-center pb-4 lg:pb-8"
        >
            <div v-if="type === PlanFeaturesAccessEnum.BookingFormTheme">
                <div class="text-2xl lg:text-3xl font-bold text-gray-900">
                    Plan upgrade required
                </div>
                <div class="text-lg text-gray-600 mt-2">
                    You need to upgrade your subscription plan in order to
                    customize your booking form.
                </div>
            </div>

            <div v-if="type === PlanFeaturesAccessEnum.CustomFields">
                <div class="text-2xl lg:text-3xl font-bold text-gray-900">
                    Plan upgrade required
                </div>
                <div class="text-lg text-gray-600 mt-2">
                    You need to upgrade your subscription plan in order to add
                    custom fields to your booking page.
                </div>
            </div>

            <div v-if="type === PlanFeaturesAccessEnum.ExternalCalendarCheck">
                <div class="text-2xl lg:text-3xl font-bold text-gray-900">
                    Plan upgrade required
                </div>
                <div class="text-lg text-gray-600 mt-2">
                    You need to upgrade your subscription plan in order to check
                    your external calendar for conflicts.
                </div>
            </div>

            <div v-if="type === PlanFeaturesAccessEnum.ExternalCalendarSync">
                <div class="text-2xl lg:text-3xl font-bold text-gray-900">
                    Plan upgrade required
                </div>
                <div class="text-lg text-gray-600 mt-2">
                    You need to upgrade your subscription plan in order to sync
                    external calendar events with your availability.
                </div>
            </div>

            <div v-if="type === PlanFeaturesAccessEnum.PaymentsStripe">
                <div class="text-2xl lg:text-3xl font-bold text-gray-900">
                    Plan upgrade required
                </div>
                <div class="text-lg text-gray-600 mt-2">
                    You need to upgrade your subscription plan in order to
                    collect payments with Stripe.
                </div>
            </div>

            <div
                v-if="
                    type === PlanFeaturesAccessEnum.SingleHostMultipleAttendee
                "
            >
                <div class="text-2xl lg:text-3xl font-bold text-gray-900">
                    Plan upgrade required
                </div>
                <div class="text-lg text-gray-600 mt-2">
                    You need to upgrade your subscription plan in order to
                    access group scheduling.
                </div>
            </div>

            <div v-if="type === PlanFeaturesAccessEnum.RecurringMeeting">
                <div class="text-2xl lg:text-3xl font-bold text-gray-900">
                    Plan upgrade required
                </div>
                <div class="text-lg text-gray-600 mt-2">
                    You need to upgrade your subscription plan in order to
                    access recurring meetings.
                </div>
            </div>

            <div
                v-if="
                    quantity && type === PlanFeaturesQuantityEnum.CompanyUsers
                "
            >
                <div class="text-2xl lg:text-3xl font-bold text-gray-900">
                    Plan upgrade required
                </div>
                <div class="text-lg text-gray-600 mt-2">
                    You reached the maximum number of {{ quantity }} company
                    users. Please upgrade to a higher plan to add more users.
                </div>
            </div>
        </div>

        <div class="space-y-4">
            <div class="grid grid-cols-12 gap-4 items-center">
                <div
                    v-for="plan in plans"
                    :key="plan.id.value"
                    class="col-span-12 md:col-span-6 lg:col-span-4"
                >
                    <PlanCard
                        @checkoutStarted="isDisabled = true"
                        :isDisabled="isDisabled"
                        :plan="plan"
                        :changePlan="changePlan"
                    />
                </div>
            </div>
        </div>
    </AppLayout>
</template>

<script setup lang="ts">
    import { ref } from 'vue'
    import Plan from '@/App/Plan/Entity/Plan'
    import AppLayout from '@/Shared/Layout/App/Sidebar/AppLayout.vue'
    import PlanCard from '@/App/Plan/Component/PlanCard.vue'
    import {
        PlanFeaturesAccessEnum,
        PlanFeaturesQuantityEnum,
        type PageMeta,
    } from '@/Shared/AutoGenerated/Main'
    import AppSharedData from '@/Shared/Entity/AppSharedData'

    interface IndexPlansProps {
        pageMeta: PageMeta
        appSharedDataData: any
        plansData: any
        type: string | null
        quantity: number | null
        changePlan: boolean
    }

    const props = defineProps<IndexPlansProps>()
    const appSharedData = AppSharedData.hydrate(props.appSharedDataData)
    const isDisabled = ref<boolean>(false)
    const plans = ref<Plan[]>(Plan.hydrateMultiple(props.plansData))
</script>
